import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { DropzoneArea } from "material-ui-dropzone";
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid,
    MenuItem,
    Button,
    TextareaAutosize
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { installmentsCreate } from '../../actions/installmentAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'id', label: 'ID', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
    { id: 'email', label: 'Email', alignRight: false },
    { id: 'action', label: 'Actions', alignRight: false },
];

const min = 1;
const date = new Date();
const f_date = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();


function CreateInstallmentPlan(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [files, setFiles] = useState([]);
    const [value, setValue] = useState('');
    
    const AddSchema = Yup.object().shape({
        loan_amount: Yup.string().required('Loan Amount is required'),
        frequency: Yup.string().required('Frequency is required'),
        number_of_payments: Yup.number().positive().min(1,"Number of payments should be greater than 0").required('Number of payments is required'),
        interest_rate: Yup.string().required('Interest Rate is required'),
        payment_amount: Yup.string().required('Payment Amount is required'),
        description: Yup.string().required('Description is required'),
    });

    const formik = useFormik({
        initialValues: {
            agreement_id:props.agreement.id,
            client: props.agreement.car.buyer_name,
            provider: 'SLEEK TRADING LTD.',
            loan_amount: props.agreement.car.balance,
            frequency: '',
            number_of_payments: '',
            total_today_due:'',
            payment_amount: '',
            interest_rate: 0,
            description:'',
            start_date:f_date
        },
        validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            // console.log(values);
            props.installmentsCreate(values);
        }
    });

    useEffect(() => {
        setIsLoading(false);
        if(props.alerts.status == 'success') {
            props.onDismis();
        }
        if(props.alerts.status == 'success') {
            navigate('/dashboard/installments', { replace: true });
        }
    }, [props.alerts]);

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, handleChange, handleBlur } = formik;

    useEffect(() => {
        if(values.number_of_payments) {
            var loan_amount = props.agreement.car.balance;
            var calculated_value = loan_amount/Number(values.number_of_payments);
            var f_value = _.round(calculated_value,2);
            values.payment_amount = f_value;
            values.total_today_due = loan_amount - f_value;
        } else {
            values.payment_amount = 0;
            values.total_today_due = 0;
        }
    },[values.number_of_payments]);

    return (
        <Page title="CreateAgreement">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack sx={{ mb: 5 }}>
                                <Typography sx={{ color: 'text.secondary' }} gutterBottom>Car Details</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <b>Client:</b> {!_.isEmpty(props.agreement) && props.agreement.car.buyer_name}
                                    </Grid>
                                    <Grid item xs={6}>
                                        <b>Provider:</b> SLEEK TRADING LTD.
                                    </Grid>
                                    <Grid item xs={6}>
                                        <b>Loan Amount:</b>  {!_.isEmpty(props.agreement) && props.agreement.car.balance}
                                    </Grid>
                                    <Grid item xs={6}>
                                        <b>Interest Rate:</b>  0.00%
                                    </Grid>
                                    <Grid item xs={6} sx={{marginBottom:"10px"}}>
                                        <b>Start Date:</b>  {f_date}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Stack spacing={3}>
                                            <TextField
                                                fullWidth
                                                select
                                                label="Select Frequency*"
                                                {...getFieldProps('frequency')}
                                                error={Boolean(touched.frequency && errors.frequency)}
                                                helperText={touched.frequency && errors.frequency}
                                            >
                                                <MenuItem  value="monthly">
                                                    Monthly
                                                </MenuItem>
                                            </TextField>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Stack spacing={3}>
                                            {/* <TextField
                                                fullWidth
                                                InputProps={{ inputProps: { min: 0, max: 10 } }}
                                                label="Num Payment*"
                                                {...getFieldProps('number_of_payments')}
                                                error={Boolean(touched.number_of_payments && errors.number_of_payments)}
                                                helperText={touched.number_of_payments && errors.number_of_payments}
                                            >
                                            </TextField> */}
                                            <TextField
                                                label="Num Payment*"
                                                type="number"
                                                name='number_of_payments'
                                                {...getFieldProps('number_of_payments')}
                                                error={Boolean(touched.number_of_payments && errors.number_of_payments)}
                                                helperText={touched.number_of_payments && errors.number_of_payments}
                                            />
                                            {/* <input type="text" pattern="[0-9]*" onInput={handleChangeField} value={financialGoal} /> */}
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            type="text"
                                            label="Payment Amount*"
                                            {...getFieldProps('payment_amount')}
                                            error={Boolean(touched.payment_amount && errors.payment_amount)}
                                            helperText={touched.payment_amount && errors.payment_amount}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            type="text"
                                            label="Total Today Due*"
                                            {...getFieldProps('total_today_due')}
                                            error={Boolean(touched.total_today_due && errors.total_today_due)}
                                            helperText={touched.total_today_due && errors.total_today_due}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Description*"
                                            {...getFieldProps('description')}
                                            error={Boolean(touched.description && errors.description)}
                                            helperText={touched.description && errors.description}
                                        />
                                    </Grid>
                                </Grid>
                            </Stack>
                            <LoadingButton
                                size="medium"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',float:"right"}}
                            >
                                create
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
    }
}

export default connect(mapStateToProps, { installmentsCreate })(CreateInstallmentPlan);

